import { render } from "./ExtrasForm.vue?vue&type=template&id=23ad926a&lang=pug"
import script from "./ExtrasForm.vue?vue&type=script&lang=js"
export * from "./ExtrasForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__